import { FORM_MODE, Permissions, EventTypes } from '@awp/constants';

export const criticalFieldEntity = (cf, values, isPath) => {
  if (!cf) return null;
  let _entity = { ...cf };

  if (!isPath) {
    if (values.segment && values.segment.value) {
      _entity.GeographicLineId = values.segment.value;
      _entity.GeographicPointIds = null;
      _entity.GeographicAreaId = values.area.value;
      _entity.ParentGeographicAreaId = values.area.parentId;
    }
    if (values.fromPoint && values.fromPoint.value && values.toPoint && values.toPoint.value) {
      _entity.GeographicPointIds = `${values.fromPoint.value},${values.toPoint.value}`;
      _entity.GeographicLineId = null;
      _entity.GeographicAreaId = values.area.value;
      _entity.ParentGeographicAreaId = values.area.parentId;
    }
  }
  return _entity;
};
export const criticalFieldsToEntity = (cfs, values) => {
  if (!cfs) return null;
  let _entity = criticalFieldEntity(cfs, values, checkEventType(cfs.EventTypeNm));
  if (cfs.ChildAvalancheProcessedEvents && Array.isArray(cfs.ChildAvalancheProcessedEvents)) {
    let _children = [];
    cfs.ChildAvalancheProcessedEvents.map((c) => {
      let _c = criticalFieldEntity(c, values, checkEventType(c.EventTypeNm));
      if (c.ChildAvalancheProcessedEvents && Array.isArray(c.ChildAvalancheProcessedEvents)) {
        let _gChildren = [];
        c.ChildAvalancheProcessedEvents.map((gc) => {
          let _gc = criticalFieldEntity(gc, values, checkEventType(gc.EventTypeNm));
          _gChildren.push(_gc);
        });
        _c.ChildAvalancheProcessedEvents = _gChildren;
      }
      _children.push(_c);
    });
    _entity.ChildAvalancheProcessedEvents = _children;
  }

  return _entity;
};

export const checkEventType = (evt) => {
  if (
    (evt + '').toLocaleUpperCase() === EventTypes.AvalancheControl.toLocaleUpperCase() ||
    (evt + '').toLocaleUpperCase() === EventTypes.AvalancheOccurrence.toLocaleUpperCase()
  )
    return true;
  return false;
};

export const findEventTypeNmById = (eventData, targetEventId) => {
  // Check if current object's EventId matches the target
  if (eventData.EventId === targetEventId) {
    return eventData.EventTypeNm;
  }

  // Check if ChildAvalancheProcessedEvents exists and is an array
  if (eventData.ChildAvalancheProcessedEvents && Array.isArray(eventData.ChildAvalancheProcessedEvents)) {
    for (let child of eventData.ChildAvalancheProcessedEvents) {
      // Recursive call for each child
      const result = findEventTypeNmById(child, targetEventId);
      if (result) return result; // Return if found
    }
  }

  // If not found, return null
  return null;
};

export const getTimeLabel = (evt) => {
  if ((evt + '').toLocaleUpperCase() === EventTypes.AvalancheControl.toLocaleUpperCase()) {
    return 'Initiation Date/Time';
  } else if ((evt + '').toLocaleUpperCase() === EventTypes.AvalancheOccurrence.toLocaleUpperCase()) {
    return 'Occurrence Date/Time';
  } else if ((evt + '').toLocaleUpperCase() === EventTypes.RoadClosure.toLocaleUpperCase()) {
    return 'Road Closed';
  }
  return 'Date/Time';
};
export const isPathEvent = (dto) => {
  if (!dto) return false;
  if (dto.avalanche_program && dto.avalanche_area && dto.avalanche_path && dto.avalanche_path.value) return true;
  return false;
};
export const isCriticalFieldsUpdated = (criticalFields, values, _originalValues) => {
  if (_originalValues && values) {
    if (
      !criticalFields &&
      isPathEvent(values) &&
      ((_originalValues.avalanche_area &&
        _originalValues.avalanche_area.value &&
        values.avalanche_area &&
        values.avalanche_area.value &&
        _originalValues.avalanche_area.value !== values.avalanche_area.value) ||
        (values.avalanche_path &&
          values.avalanche_path.areaId &&
          _originalValues.avalanche_path &&
          _originalValues.avalanche_path.areaId !== values.avalanche_path.areaId))
    ) {
      return true;
    }
    if (
      !criticalFields &&
      ((_originalValues.area &&
        _originalValues.area.value &&
        values.area &&
        values.area.value &&
        _originalValues.area.value !== values.area.value) ||
        (values.segment &&
          values.segment.value &&
          (!_originalValues.segment || _originalValues.segment.value !== values.segment.value)) ||
        (values.fromPoint &&
          values.fromPoint.value &&
          (!_originalValues.fromPoint || _originalValues.fromPoint.value !== values.fromPoint.value)) ||
        (values.toPoint &&
          values.toPoint.value &&
          (!_originalValues.toPoint || _originalValues.toPoint.value !== values.toPoint.value)))
    ) {
      return true;
    }
  }
  return false;
};
export const getSegmentId = (dto) => {
  if (!dto) return null;
  return dto.GeographicLineId;
};
export const getFromId = (dto) => {
  if (!dto) return null;
  if (dto.GeographicPointIds) {
    const ids = dto.GeographicPointIds.split(',').map(Number);
    return ids[0];
  }
  return dto.GeographicPointIds;
};
export const getToId = (dto) => {
  if (!dto) return null;
  if (dto.GeographicPointIds) {
    const ids = dto.GeographicPointIds.split(',').map(Number);
    return ids[1];
  }
  return dto.GeographicPointIds;
};
export const locationCriticalFieldEntity = (cf, values, isPath) => {
  if (!cf) return null;
  let _entity = { ...cf };
  if (!isPath) {
    if (cf.GeographicLineId) _entity.GeographicPointIds = null;
    if (cf.GeographicPointIds) _entity.GeographicLineId = null;
  } else {
    if (cf.EventId === values.eventId) {
      _entity.GeographicAreaId = values.avalanche_path.areaId;
      _entity.ParentGeographicAreaId = values.avalanche_path.parentId;
    }
  }
  return _entity;
};
export const locationCriticalFieldsToEntity = (cfs, values) => {
  if (!cfs) return null;
  let _entity = locationCriticalFieldEntity(cfs, values, checkEventType(cfs.EventTypeNm));
  if (cfs.ChildAvalancheProcessedEvents && Array.isArray(cfs.ChildAvalancheProcessedEvents)) {
    let _children = [];
    cfs.ChildAvalancheProcessedEvents.map((c) => {
      let _c = locationCriticalFieldEntity(c, values, checkEventType(c.EventTypeNm));
      if (c.ChildAvalancheProcessedEvents && Array.isArray(c.ChildAvalancheProcessedEvents)) {
        let _gChildren = [];
        c.ChildAvalancheProcessedEvents.map((gc) => {
          let _gc = locationCriticalFieldEntity(gc, values, checkEventType(gc.EventTypeNm));
          _gChildren.push(_gc);
        });
        _c.ChildAvalancheProcessedEvents = _gChildren;
      }
      _children.push(_c);
    });
    _entity.ChildAvalancheProcessedEvents = _children;
  }

  return _entity;
};
